import { combineReducers } from 'redux';
import education, {
  fetchEducationChangeRecords,
  fetchEducationEffectiveData,
  addCertificationChangeRecord,
  removeCertificationChangeRecord,
} from './education';
import certification, {
  fetchCertificationChangeRecords,
  fetchCertificationEffectiveData,
  addEducationChangeRecord,
  removeEducationChangeRecord,
} from './certification';

export default combineReducers({
  education,
  certification,
});

export {
  fetchEducationChangeRecords,
  fetchEducationEffectiveData,
  addCertificationChangeRecord,
  removeCertificationChangeRecord,
  fetchCertificationChangeRecords,
  fetchCertificationEffectiveData,
  addEducationChangeRecord,
  removeEducationChangeRecord,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/screens/CertificationAndEducationInfo/reducers/index.js
 **/